import { NgModule, ErrorHandler, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from './loader/create-translate-loader';
import { IonicStorageModule } from '@ionic/storage-angular';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';

// Tjenester og annet
import { AppSettings } from './shared/app-settings';
import { BaseHttpClient } from './shared/http-client';
import { BaseHttpClient2 } from './shared/http-client2';
import { CompanyService } from './shared/company-service';
import { UserService } from './shared/user-service';
import { AuthService } from './shared/auth-service';
import { KCMAErrorHandler } from './shared/kcma-error-handler';
import { FormSchemaService } from './services/form-schema.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { API_URL, ERP_ID_PARENT, IS_CUSTOMER_NO } from './shared/tokens';

// Interceptor
import { AngularInterceptor } from './app.module.interceptor'; // du kan flytte denne til egen fil om ønskelig

// Shared module (som inneholder LogoutComponent, pipes, directives, IonicSelectable, etc.)
import { SharedModule } from './shared/shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
  declarations: [
    AppComponent // bare AppComponent her
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    IonicModule.forRoot(),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule, // inneholder felles komponenter og moduler
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    IonicStorageModule.forRoot(),
    LeafletModule,
    AngularSignaturePadModule,
    DragulaModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    BaseHttpClient,
    BaseHttpClient2,
    CompanyService,
    UserService,
    AuthService,
    FormSchemaService,
    DragulaService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AngularInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: KCMAErrorHandler },
    { provide: API_URL, useValue: AppSettings.API_ENDPOINT },
    { provide: ERP_ID_PARENT, useValue: 0 },
    { provide: IS_CUSTOMER_NO, useValue: false },
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
